import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectSelectedChannel, selectVideoCall } from '../../../../store/app.selectors';
import { setVideoCall } from '../../store/chat.actions';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-open-modal',
  templateUrl: './open-modal.component.html',
  styleUrls: ['./open-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OpenModalComponent {
  @Input() room: string;

  private store = inject(Store<AppStateWithChat>);

  videoCall = toSignal(this.store.select(selectVideoCall), { initialValue: null });
  selectedChannel = toSignal(this.store.select(selectSelectedChannel), { initialValue: null });

  open(): void {
    if (!this.videoCall()) {
      const channel = this.selectedChannel();
      if (!channel) {
        return;
      }
      this.store.dispatch(setVideoCall({ videoCall: { room: this.room, name: channel.displayName, type: 1 } }));
    }
  }
}
